<template>
  <div>
    <Modal
      v-model="visible"
      :mask-closable="false"
      :closable="false"
      width="940"
      class="batch-setting"
      :class="{ 'small-head': !detail.isCommon }"
      :footer-hide="true"
    >
      <loading :isShow="pageLoading" />
      <div solt="title" class="title-box">
        <div class="modal-title" v-if="!detail.isCommon">新产品批量预设服务费</div>
        <div class="modal-title" v-else-if="isTop">批量配置模板服务费</div>
        <div class="modal-title" v-else>批量配置{{ label[detail.type] }}服务费</div>
        <div class="title-info" v-if="!detail.isCommon || detail.isNewTemplate">此后新增产品将自动按下方比例完成服务费配置，您也可以随时修改</div>
      </div>
      <div class="table-title" v-if="isLongOrShort[0]">长险</div>
      <div class="table" v-if="isLongOrShort[0]">
        <div class="head">
          <div class="td first-td"></div>
          <div class="td">首年(%)</div>
          <div class="td">第二年(%)</div>
          <div class="td">第三年(%)</div>
          <div class="td">第四年(%)</div>
          <div class="td">第五年(%)</div>
        </div>
        <div class="body" v-for="(item, i) in list1" :key="i">
          <div class="td first-td" v-if="detail.type == 2">{{ item.label }}</div>
          <div class="td first-td" v-else>应用{{ label[detail.type] }}服务费=上级服务费 X</div>
          <div class="td">
            <div class="ivu-input-wrapper" :class="{ error: item.firstYearError }">
              <input
                :value="item.firstYearValue"
                placeholder="请输入"
                class="ivu-input"
                type="number"
                @input="inputChange($event, item, 'firstYearValue', list1, i)"
                step="0.01"
              />
            </div>
          </div>
          <div class="td">
            <div class="ivu-input-wrapper" :class="{ error: item.secondYearError }">
              <input
                :value="item.secondYearValue"
                placeholder="请输入"
                class="ivu-input"
                type="number"
                @input="inputChange($event, item, 'secondYearValue', list1, i)"
                step="0.01"
              />
            </div>
          </div>
          <div class="td">
            <div class="ivu-input-wrapper" :class="{ error: item.thirdYearError }">
              <input
                :value="item.thirdYearValue"
                placeholder="请输入"
                class="ivu-input"
                type="number"
                @input="inputChange($event, item, 'thirdYearValue', list1, i)"
                step="0.01"
              />
            </div>
          </div>
          <div class="td">
            <div class="ivu-input-wrapper" :class="{ error: item.fourthYearError }">
              <input
                :value="item.fourthYearValue"
                placeholder="请输入"
                class="ivu-input"
                type="number"
                @input="inputChange($event, item, 'fourthYearValue', list1, i)"
                step="0.01"
              />
            </div>
          </div>
          <div class="td">
            <div class="ivu-input-wrapper" :class="{ error: item.fifthYearError }">
              <input
                :value="item.fifthYearValue"
                placeholder="请输入"
                class="ivu-input"
                type="number"
                @input="inputChange($event, item, 'fifthYearValue', list1, i)"
                step="0.01"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="table-title" v-if="isLongOrShort[1]">短险</div>
      <div class="table" v-if="isLongOrShort[1]">
        <div class="head">
          <div class="td first-td"></div>
          <div class="td">新单(%)</div>
          <div class="td">续保(%)</div>
        </div>
        <div class="body" v-for="(item, i) in list2" :key="i">
          <div class="td first-td" v-if="detail.type == 2">{{ item.label }}</div>
          <div class="td first-td" v-else>应用{{ label[detail.type] }}服务费=上级服务费 X</div>
          <div class="td">
            <div class="ivu-input-wrapper" :class="{ error: item.firstYearError }">
              <input
                :value="item.firstYearValue"
                placeholder="请输入"
                class="ivu-input"
                type="number"
                @input="inputChange($event, item, 'firstYearValue', list2, i)"
                step="0.01"
              />
            </div>
          </div>
          <div class="td">
            <div class="ivu-input-wrapper" :class="{ error: item.secondYearError }">
              <input
                :value="item.secondYearValue"
                placeholder="请输入"
                class="ivu-input"
                type="number"
                @input="inputChange($event, item, 'secondYearValue', list2, i)"
                step="0.01"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="text" v-if="userInfo.orgType == 1">
        <span class="tips">保留小数位：服务费率乘以费率比可能会出现小数，您可以设置保留百分号前小数的位数和取值规则</span>
        <span class="set-page-to" @click="$router.push('/systemSet/systemConfig?tab=commissionRateConfig')">去设置>></span>
      </div>
      <!-- <div class="table-title">举例</div>
      <div class="text" v-if="detail.type == 2">
        上级服务费为80.00%，您在此为{{ label2[detail.type] }}的长险首年设定的服务费占比为72.00%，则{{ label2[detail.type] }}所有长险产品首年推广费为80.00% ×
        72.00%=57.60%， 团队长和团员每年的服务费比例之和不能超过上级机构服务费的100%。
      </div>
      <div class="text" v-else>
        上级服务费为80.00%，您在此为{{ label2[detail.type] }}的长险首年设定的服务费占比为72.00%，则{{ label2[detail.type] }}所有长险产品首年推广费为80.00% ×
        72.00%=57.60%， 默认保留2位小数，那么上级剩余为80.00%-57.60%=22.40%
      </div> -->
      <div class="ivu-modal-footer">
        <Button type="text" @click="closeModal">取消</Button>
        <Button type="primary" @click="saveAddProductSetting">确定</Button>
      </div>
    </Modal>

    <!-- 进度弹窗 -->
    <modalLoading ref="loading"></modalLoading>
  </div>
</template>

<script>
import modalLoading from '@/components/commons/modalLoading';
export default {
  components: { modalLoading },
  props: { isTop: null },
  data() {
    return {
      pageLoading: false,
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      list1: [],
      list2: [],
      label: ['商户', '机构', '团队'],
      label2: ['应用商户', '应用机构', '业务员'],
      teamList1: [
        {
          label: '团队长管理费=上级服务费  X',
          policyType: 1,
          commissionType: 2,
          firstYearValue: '',
          secondYearValue: '',
          thirdYearValue: '',
          fourthYearValue: '',
          fifthYearValue: ''
        },
        {
          label: '业务员服务费=上级服务费  X',
          policyType: 1,
          commissionType: 3,
          firstYearValue: '',
          secondYearValue: '',
          thirdYearValue: '',
          fourthYearValue: '',
          fifthYearValue: ''
        }
      ],
      teamList2: [
        {
          label: '团队长管理费=上级服务费  X',
          policyType: 2,
          commissionType: 2,
          firstYearValue: '',
          secondYearValue: ''
        },
        {
          label: '业务员服务费=上级服务费  X',
          policyType: 2,
          commissionType: 3,
          firstYearValue: '',
          secondYearValue: ''
        }
      ],
      mechanList1: [
        {
          label: '应用机构服务费=上级服务费  X',
          policyType: 1,
          commissionType: 1,
          firstYearValue: '',
          secondYearValue: '',
          thirdYearValue: '',
          fourthYearValue: '',
          fifthYearValue: ''
        }
      ],
      mechanList2: [
        {
          label: '应用机构服务费=上级服务费  X',
          policyType: 2,
          commissionType: 1,
          firstYearValue: '',
          secondYearValue: ''
        }
      ],
      form1: {}, //机构 长险数据
      form2: {}, //机构 短险数据
      form3: {}, //团队长 长险数据
      form4: {}, //业务员 长险数据
      form5: {}, //团队长 短险数据
      form6: {}, //业务员 短险数据
      visible: false,
      detail: {}, //模板详情数据
      isLongOrShort: [true, true], //选中的产品是否有长短险
      isNewTemplate: null
    };
  },

  methods: {
    // 提交新产品预设
    saveAddProductSetting() {
      if (!this.detail.isCommon || this.detail.isNewTemplate) {
        const params = {
          longRateLists: this.convertData(this.list1),
          shortRateLists: this.convertData(this.list2),
          isSys: 0
        };
        if (this.detail.isNewTemplate) {
          params.isAdd = 1;
          params.templateId = this.detail.templateId || this.detail.template.id;
        }
        if (this.pageLoading) {
          return;
        }
        this.pageLoading = true;
        this.$http({
          url: '/buz/templateConfig/saveConfigs',
          type: 'post',
          data: params,
          apiPermissionCode: this.detail.apiPermissionCode
        })
          .then(res => {
            this.$notice.success('保存成功');
            this.visible = false;
          })
          .finally(() => {
            window.setTimeout(() => {
              this.pageLoading = false;
            }, 200);
          });
      } else {
        this.editTemplate();
      }
    },
    // 取消关闭弹窗
    closeModal() {
      this.visible = false;
      if (this.detail.isConfig && !this.detail.templateId && this.detail.organizationProducts.length) {
        this.$emit('sync-organization-product', this.detail.organizationProducts);
      }
    },
    // 转换提交数据
    convertData(list) {
      const out = [];
      list.forEach(item => {
        item.firstYearId && out.push({ id: item.firstYearId, value: item.firstYearValue || 0 });
        item.secondYearId && out.push({ id: item.secondYearId, value: item.secondYearValue || 0 });
        if (item.policyType == 1) {
          item.thirdYearId && out.push({ id: item.thirdYearId, value: item.thirdYearValue || 0 });
          item.fourthYearId && out.push({ id: item.fourthYearId, value: item.fourthYearValue || 0 });
          item.fifthYearId && out.push({ id: item.fifthYearId, value: item.fifthYearValue || 0 });
        }
      });
      return out;
    },
    yz(list) {
      let error = false;
      list.forEach(item => {
        if (item.firstYearValue === '') {
          error = true;
          item.firstYearError = true;
        }
        if (item.secondYearValue === '') {
          error = true;
          item.secondYearError = true;
        }
        if (item.hasOwnProperty('thirdYearValue') && item.thirdYearValue === '') {
          error = true;
          item.thirdYearError = true;
        }
        if (item.hasOwnProperty('fourthYearValue') && item.fourthYearValue === '') {
          error = true;
          item.fourthYearError = true;
        }
        if (item.hasOwnProperty('fifthYearValue') && item.fifthYearValue === '') {
          error = true;
          item.fifthYearError = true;
        }
      });
      if (error) {
        this.$forceUpdate();
        this.$notice.msg('请填写服务费');
        return false;
      }
      return true;
    },
    // 新增模板的批量配费
    addNewTemplate() {
      const params = {
        template: this.detail.template,
        templateProductDTO: this.detail.templateProductDTO,
        templateConfigDTO: {
          items: list
        }
      };
      return this.$http({
        url: this.isTop ? '/buz/template/add' : '/buz/template/merchants/add',
        type: 'post',
        data: params
      });
    },
    // 服务费模板的批量配费
    async editTemplate() {
      let list = [];
      if (this.isLongOrShort[0]) {
        list = list.concat(this.list1);
      }
      if (this.isLongOrShort[1]) {
        list = list.concat(this.list2);
      }
      if (!this.yz(list)) {
        return;
      }
      const params = {
        productCodes: this.detail.productCodes,
        isAll: this.detail.isAll,
        orgType: this.detail.type,
        orgId: this.detail.orgId,
        templateConfigDTO: {
          items: list
        },
        ...this.detail.search
      };

      if (this.detail.templateId) {
        params.templateConfigDTO.templateId = this.detail.templateId;
      }

      if (this.detail.isConfig && !this.detail.templateId) {
        delete params.templateConfigDTO.templateId;
      }
      if (this.pageLoading) {
        return;
      }
      this.pageLoading = false;
      params.isAllVersion = true;
      try {
        await this.$notice.inquiry(`是否对未来版本也生效？`,['是','否']);
      } catch (e) {
        params.isAllVersion = false;
      }
      this.$refs.loading.open({
        title: '正在联动调整产品服务费，请稍等',
        content:
          '调整规则：按照原费率在上级费率中的占比进行调整<p>(如，上级为80%，下级为40%，即下级占上级费率的50%，当上级下调至30%时，系统将自动根据下级的原服务费占比，进行下调，即下级调至15%)</p>'
      });
      this.$http({
        url: this.detail.isConfig ? '/buz/productBase/modify/productCommission' : '/buz/commission/batchModify',
        type: 'post',
        data: params,
        apiPermissionCode: this.detail.apiPermissionCode
      })
        .then(res => {
          window.setTimeout(() => {
            this.pageLoading = false;
          }, 200);
          this.visible = false;
          this.$emit('success');
          this.$refs.loading.setText({
            title: `完成！`,
            progress: 100
          });
          // 费用配置新增产品未配置模板
          if (this.detail.isConfig && !this.detail.templateId && this.detail.organizationProducts.length) {
            this.$emit('sync-organization-product', this.detail.organizationProducts);
          }
        })
        .catch(e => {
          console.log(e);
          window.setTimeout(() => {
            this.pageLoading = false;
          }, 200);
          this.$refs.loading.close();
        });
    },

    // 监控文本框输入
    inputChange(e, form, key, list, i) {
      if (e.data == '.') {
        return;
      }
      if (e.target.value) {
        this.$set(form, key.replace('Value', 'Error'), false);
      } else {
        this.$set(form, key.replace('Value', 'Error'), true);
      }
      if (this.detail.type == 1 || this.isTop) {
        this.mechanInputChange(e, form, key);
      } else {
        this.teamInputChange(e, form, key, list, i);
      }
    },
    // 团队类型文本处理
    teamInputChange(e, form, key, list, i) {
      let curValue = e.target.value;
      const otherIndex = 1 - i;
      const otherValue = list[otherIndex][key] || 0;
      const sum = 100 - otherValue;
      if (isNaN(curValue)) {
        curValue = '0';
        e.target.value = curValue;
        this.$set(form, key, curValue);
      }
      const feeArr = curValue.toString().split('.');
      // 小数位超过2位舍弃后面的
      if (feeArr[1] && feeArr[1].length > 2) {
        // 避免*100出现精度问题
        curValue = Math.floor((curValue * 100).toFixed(2)) / 100;
      }
      // if(!/^[0-9]$/.test(curValue)){
      //   curValue = parseInt(curValue*1);
      // }
      if (curValue > 100) {
        curValue = 100;
      } else if (curValue < 0) {
        curValue = '0';
      }
      e.target.value = curValue;
      this.$set(form, key, curValue);

      if (otherValue > 100 - curValue) {
        this.$set(list[otherIndex], key, (100 - curValue).toFixed(2));
      }
    },
    // 机构类型文本处理
    mechanInputChange(e, form, key) {
      let curValue = e.target.value;
      if (isNaN(curValue)) {
        curValue = '0';
        e.target.value = curValue;
        this.$set(form, key, curValue);
      }
      const feeArr = curValue.toString().split('.');
      // 小数位超过2位舍弃后面的
      if (feeArr[1] && feeArr[1].length > 2) {
        // 避免*100出现精度问题
        curValue = Math.floor((curValue * 100).toFixed(2)) / 100;
      }
      // if(!/^[0-9]$/.test(curValue)){
      //   curValue = parseInt(curValue*1);
      // }
      if (curValue > 100) {
        curValue = 100;
      } else if (curValue < 0) {
        curValue = '0';
      }
      e.target.value = curValue;
      this.$set(form, key, curValue);
    },
    /**
     * 初始化
     * {
     * isCommon 是否是通用设置
     * isLongOrShort:[true,true] 是否是长险短险[长险,短险]
     * isAll 是否全选
     * templateId 模板id
     * type 模板类型 1机构 2团队
     * productCodes:[] 批量配置的产品code
     * orgId 机构id
     * isConfig 是否是模板配置
     * }
     */
    open(detail, isNewTemplate) {
      this.detail = detail;
      this.isNewTemplate = isNewTemplate;
      if ((!detail.isConfig && !detail.isCommon) || detail.isNewTemplate) {
        this.commonSettingInit(detail);
      } else {
        this.batchSettingInit(detail);
      }
    },
    // 批量设置初始化
    batchSettingInit(detail) {
      if (this.detail.type == 2) {
        this.list1 = JSON.parse(JSON.stringify(this.teamList1));
        this.list2 = JSON.parse(JSON.stringify(this.teamList2));
      } else {
        this.list1 = JSON.parse(JSON.stringify(this.mechanList1));
        this.list2 = JSON.parse(JSON.stringify(this.mechanList2));
      }
      if (detail.isLongOrShort && detail.isLongOrShort.length == 2) {
        this.isLongOrShort = detail.isLongOrShort;
      } else {
        this.isLongOrShort = [true, true];
      }
      if (detail.search && detail.search.productType == 1) {
        //长险
        this.isLongOrShort = [true, false];
      } else if (detail.search && detail.search.productType == 2) {
        //短险
        this.isLongOrShort = [false, true];
      } else if (detail.isAll) {
        this.isLongOrShort = [true, true];
      }
      this.visible = true;
    },

    // 新产品预设初始化
    commonSettingInit(detail) {
      this.isLongOrShort = [true, true];
      this.$http({
        url: '/buz/templateConfig/read/detail',
        type: 'get',
        data: {
          templateId: detail.templateId || detail.template.id
        }
      }).then(res => {
        let list1 = [];
        let list2 = [];
        if (this.detail.type == 2) {
          list1 = JSON.parse(JSON.stringify(this.teamList1));
          list2 = JSON.parse(JSON.stringify(this.teamList2));
        } else {
          list1 = JSON.parse(JSON.stringify(this.mechanList1));
          list2 = JSON.parse(JSON.stringify(this.mechanList2));
        }
        this.setValue(list1, res.data.longRateLists);
        this.setValue(list2, res.data.shortRateLists);
        this.list1 = list1;
        this.list2 = list2;
        this.visible = true;
      });
    },

    setValue(targetList, data) {
      targetList.forEach((item, i) => {
        const curData = data[i];
        if (curData.firstYear) {
          item.firstYearValue = curData.firstYear.value;
          item.firstYearId = curData.firstYear.id;
        }
        if (curData.secondYear) {
          item.secondYearValue = curData.secondYear.value;
          item.secondYearId = curData.secondYear.id;
        }
        if (curData.thirdYear) {
          item.thirdYearValue = curData.thirdYear.value;
          item.thirdYearId = curData.thirdYear.id;
        }
        if (curData.fourthYear) {
          item.fourthYearValue = curData.fourthYear.value;
          item.fourthYearId = curData.fourthYear.id;
        }
        if (curData.fifthYear) {
          item.fifthYearValue = curData.fifthYear.value;
          item.fifthYearId = curData.fifthYear.id;
        }
      });
    }
  }
};
</script>
<style lang="scss">
@import './batchSetting.scss';
</style>
